// extracted by mini-css-extract-plugin
export default {"detail":"Checkout_detail__Z0mZM","detail__back":"Checkout_detail__back__nifMZ","detail__left":"Checkout_detail__left__rx0AD","detail__right":"Checkout_detail__right__rUKmZ"};